import React from 'react';

const PhysicalEducation = () => {
  return (
    <div>
      PhysicalEducation
      PhysicalEducation
    </div>
  );
}

export default PhysicalEducation;
